<template>
	<div class="main" v-title data-title="零部件内容页" v-cloak>
		<iHeader ref="loginIndex"></iHeader>
		<!-- :class="flag404==true?'disblock':'disnone'"
		 :class="flag404==false?'disblock':'disnone'"{{flag404}}{{flagshow}}
		 -->
		<div style="min-height:600px;">
			<div v-if="flag404" class="flexRow justBetween barprebox bgwhite mt20">
				<img src="https://static.mfcad.com/lingbujian/pc-img/404.jpg" style="margin: 0px auto;">
			</div>
			<div v-show="flagshow" v-cloak>
				<div class="flexRow justBetween barprebox">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-for="(item,index) in handLoc.title" :key="index">
							<router-link v-if="item=='首页'" :to="{path:'/'}">{{item}}</router-link>
							<router-link v-else :to="{path:'/list/catelist',query:{cateid:handLoc.id[index-1]}}">
								{{item}}
							</router-link>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="flexRow justBetween barprebox">
					<!-- 右侧详情页 -->
					<div class="contR">
						<div class="flexRow pdall20 bgwhite">
							<div class="swiper" ref="choose">
								<!-- ref="content" @mousemove="handleMove" @mouseleave="handleOut" -->
								<div>
									<div class=" content" v-show="tupAndsize==true ">
										<el-carousel arrow="always" :autoplay="false" ref="carousel" @change="linkto">
											<el-carousel-item v-for="(item,index) in Imginfo" :key="item.url"
												:name="item.url">
												<viewer :images="Imginfo">
													<img :src="item.url" alt="" style="width: 410px;height: 330px;"
														class="Imgindex">12345
												</viewer>
											</el-carousel-item>
										</el-carousel>
										<!-- <div class="shadow" ref="shadow"></div> -->
									</div>
									<div v-show="tupAndsize==false">
										<iframe :src="src3d" id="3dload" width="410px" height="330px" frameborder="0"
											scrolling="no"></iframe>
									</div>
								</div>
								<div class="swiperbtn">
									<span :class="buttonIndex==2?'btnICON curhand Sactive':'btnICON curhand'"
										@click="handSwiper(2,'tup')"><i class="iconfont icon-tupian"></i></span>
									<span :class="buttonIndex==1?'btnICON curhand Sactive':'btnICON curhand'"
										@click="handSwiper(1,'3d')"><i class="iconfont icon-Dxuanzhuan"></i></span>
									<span :class="buttonIndex==3?'btnICON curhand Sactive':'btnICON curhand'"
										@click="handSwiper(3,'size')"><i class="iconfont icon-icon-test1"></i></span>
								</div>
							</div>
							<div class="larger" ref="larger">
								<img :src="imgurl" ref="big">
								<!-- <img v-for="(item,index) in Imginfo" :key="item.index" :src="item.url" ref="big"/> -->
							</div>
							<div class="goodsinfo">
								<h1 class="font18">{{infoTitle}}</h1>
								<div class="infodiv" style="width: 570px;">
									<!--@click="handCjump('company/icompany',iuserid)" -->
									<p class="mt10"><span class="w6 bold">生产厂家：</span><span class="titleS"
											@click="handCjump('company/icompany',iuserid)">{{infoData.company}}</span>
									</p>
									<p class="mt10"><span
											class="w6 bold">发货地址：</span><span>{{infoData.addresstext}}</span>
									</p>
									<p class="mt10"><span class="w6 bold">产地：</span><span>{{infoData.placetext}}</span>
									</p>
									<p class="mt10"><span class="w6 bold">样本内容：</span><span class="mr10"
											v-if="flag3d==true">3d模型</span><span class="mr10"
											v-if="flag2d==true">2d图纸</span><span class="mr10"
											v-if="flagpdf==true">PDF文档</span><span class="mr10" v-else>暂无</span>
									</p>
									<p class="mt10"><span class="w6 bold">描述：</span><span
											class="titleover">{{infoBrief}}【特长/特性】使用高信赖性的出快点</span></p>
									<p class="mt10"><span class="w6 bold">联系：</span><span class="titleS colblue"
											@click="handcontact1()">请供应商与我联系</span><span class="ml20 titleS colblue"
											@click="handcontact2()">联系供应商</span></p>
									<p class="mt10"><span class="w6 bold">型号：</span>
										<span v-if="handFlag==true" class="boderD">
											当前供有<span>{{Tcount}}</span>个型号供选择
										</span>
										<span v-else class="boderD">
											(型号已选成)
										</span>
									</p>
									<div class="tab-content">
										<!--<i v-if="index!=findata.length-1">{{connector}}</i> -->
										<div class="font14" id="floatP">
											<span v-show='RpropFlag' v-for="(item,index) in findata" :key="index">
												<span
													:class="[item.ischeck==0 ?'defaultIcon':'redIcon']" v-if="index==findata.length-2 && findata[findata.length-1].label==''">{{item.label.slice(0,item.label.length-1)}}</span>
													<span
														:class="[item.ischeck==0 ?'defaultIcon':'redIcon']" v-else>{{item.label}}</span>
													
											</span>
										</div>
										<div>
											<el-button size="mini" icon="iconfont icon-tubiao_daochuCAD" class="goSel"
												@click="handown" v-if="handFlag==false">CAD模型下载</el-button>
										</div>
									</div>
								</div>
								<p class="mt10 posrela">
									<el-link @click="handeColl()" class="csdiv" :underline="false" type="info">
										<span v-if="colFlag==true"><i class="iconfont icon-shoucang mr10"></i>收藏</span>
										<span v-else><i class="iconfont icon-collection-b mr10"></i>已收藏</span>
									</el-link>
									<el-link @click="handelike()" class="csdiv" :underline="false" type="info">
										<span v-if="likeFlag==true"><i class="iconfont icon-xihuan mr10"></i>喜欢</span>
										<span v-else><i class="iconfont icon-xihuan1 mr10"></i>已喜欢</span>
									</el-link>
								</p>

							</div>
						</div>
						<!-- 尺寸图 <p><img :src="sizeImg" alt=""></p>-->
						<div class="mt20">
							<div v-if="handFlag==false" class="bgwhite H-size">
								<h1 class="color1 font18 item1"><i class="H-line-4"></i>指定中的规格/尺寸信息
									<!-- <el-link :underline="false" class="iconS" style="float:right" icon="el-icon-search">根据规格查找同类商品></el-link> -->
								</h1>
								<el-divider class="divider20"></el-divider>
								<table-detail :tableData="tableData" :tableStyle="{ width:'100%' }"></table-detail>
							</div>
							<div class="tab-tilte font16 mt20">
								<li @click="cur=0" :class="{active:cur==0}"><i class="iconfont icon-yuedu mr10"></i>产品目录
								</li>
								<li @click="cur=1" :class="{active:cur==1}"><i
										class="iconfont icon-tubiao_daochuCAD mr10"></i>CAD模型</li>
								<li @click="cur=2" :class="{active:cur==2}"><i
										class="iconfont icon-filepdf mr10"></i>PDF下载
								</li>
								<li @click="cur=3" :class="{active:cur==3}"><i
										class="iconfont icon-goodsppesupplier mr10"></i>供应商的其他产品</li>
							</div>
							<div class="tab-cont">
								<div v-show="cur==0" class="font14 justBetween" style="position: relative;" ref="pdfH">
									<div v-if="flagpdf==true">
										<!--  -->
										<div style="display: inline;" v-if="infoPdf.length>1">
											<el-tabs tab-position="left" @tab-click="handTab" class="pdftab">
												<el-tab-pane v-for="(item,index) in infoPdf" :key="index">
													<div slot="label" @mouseover="mouseOverPdf(index)"
														@mouseleave="mouseLeavePdf(index)">
														<i class="iconfont icon-filepdf"></i>
														<span :id="'pdf'+index"
															:class="index=='0'?'showpdf':'hidepdf'">{{item.name}}</span>
													</div>
													<!-- #toolbar=0控制pdf鼠标悬浮去掉头部 -->
													<iframe :src="item.url+'#toolbar=0'" width="100%"
														height="680px"></iframe>
												</el-tab-pane>
											</el-tabs>
										</div>
										<div style="display: inline;" v-if="infoPdf.length==1">
											<div v-for="(item,index) in infoPdf" :key="index">
												<iframe :src="item.url+'#toolbar=0'" width="100%"
													height="680px"></iframe>
											</div>
										</div>
									</div>
									<div v-else-if="flagpdf==false">
										<span class="pd20">暂无pdf文件</span>
									</div>
								</div>
								<div v-show="cur==1" class="font14">
									<div class="dowFile" v-if="flagCad==false">
										<template>
											<el-row :gutter="20">
												<el-col :span="1">
													<div class="pdflist fl">
														<i class="iconfont icon-cad-fill"></i>
													</div>
												</el-col>
												<el-col :span="10">
													<div class="fl ml20">
														<p class="lin-h20"><span
																style="color: #000000;">{{modelName}}</span>
														</p>
														<p class="lin-h20"><span class="pdr20">{{addtime}}</span>
															<span>下载次数：<span class="color2">{{downnum}}</span></span>
														</p>
													</div>
												</el-col>
												<el-col :span="5">
													<div class="fl ml40">文件大小：{{cadsize}}</div>
												</el-col>
												<el-col :span="4">
													<div class="fl ml40 color2">免费下载</div>
												</el-col>
												<el-col :span="4">
													<el-button type="primary" class="spanDown" plain @click="handown()">
														<i class="el-icon-download mr10 bold"></i>模型下载
													</el-button>
												</el-col>
											</el-row>
										</template>
										<!-- <el-divider></el-divider> -->
									</div>
									<div class="flexRow justBetween dowFile" v-else-if="flagCad==true">
										<span>{{cadmessage}}</span>
									</div>
								</div>
								<div v-show="cur==2" class="font14">
									<div class="dowFile" v-for="(item,index) in infoPdf" :key="index"
										v-if="flagpdf==true">
										<el-row :gutter="20">
											<el-col :span="1">
												<div class="pdflist">
													<i class="iconfont icon-PDF"></i>
												</div>
											</el-col>
											<el-col :span="10">
												<div class="fl ml20">
													<p class="lin-h20"><span
															style="color: #000000;">{{item.name}}</span>
													</p>
													<p class="lin-h20"><span class="pdr20">{{item.addtime}}</span>
														<span>下载次数：<span class="color2">{{item.down}}</span></span>
													</p>
												</div>
											</el-col>
											<el-col :span="5">
												<div class="fl ml40">文件大小：{{item.size}}</div>
											</el-col>
											<el-col :span="4">
												<div class="fl ml40 color2">免费下载</div>
											</el-col>
											<el-col :span="4">
												<el-button type="primary" class="spanDown" plain
													@click="downPdf(item.url)">
													<i class="el-icon-download mr10 bold"></i>PDF下载
												</el-button>
											</el-col>
										</el-row>
										<el-divider v-if="infoPdf.length>1"></el-divider>
									</div>
									<div class="flexRow justBetween dowFile" v-show="flagpdf==false">
										<span>暂无pdf文件</span>
									</div>
								</div>
								<div v-show="cur==3" class="font14">
									<div class="demo-image pdall20 curhand" v-if="flagcompay==true">
										<div class="block blockInfocate" v-for="(item,index) in compaygoods"
											:key="index" @mousemove="addClassload($event)"
											@mouseout="removeClassload($event)" @click="jumpurl(item.id)"
											:title="item.catid_name">
											<el-image style="width: 210px; height: 210px"
												:src="'https://images.mfcad.cn/'+item.thumb" fit="cover"
												@mousemove="ImgaddClassload($event)"
												@mouseout="ImgremoveClassload($event)"></el-image>
											<div class="font14 txl" style="width: 100%;line-height: 20px;">
												<!-- 	<p class="mt10 Cred">¥ 46.00起</p> -->
												<p class="bold overtitle">{{ item.title}}</p>
												<p class="col-999 overtitle">{{ item.catname }}</p>

											</div>
										</div>
									</div>
									<div class="demo-image pdall20" v-else-if="flagcompay==false">
										<p class="bold">暂无数据</p>
									</div>
								</div>

							</div>
						</div>

						<!-- 收藏弹窗 -->
						<el-dialog title="收藏夹列表" :visible.sync="dialogcollectVisible" style="margin-top: 15%;">
							<div class="info-div">
								<!-- {{colList}} -->
								<el-radio-group v-model="colType" @change="changeColHandler"
									v-for="(item,index) in colList" :key="index">
									<el-radio class="radio colRadio" :label="item.id">{{item.name}}</el-radio>
								</el-radio-group>
								<div slot="footer" class="dialog-footer  txc pd20">
									<el-button type="primary" @click="handColl()">确 定</el-button>
								</div>
							</div>
						</el-dialog>
						<!-- 询价弹窗 -->
						<el-dialog title="产品明细" :visible.sync="dialogFormVisible">
							<div class="info-div">
								<div class="infoD">
									<p>产品型号/产品名称</p>
									<div class="corimg">
										<img :src="infoIMG" alt="">
									</div>
									<div class="corinfo">
										<div class="infoname">
											<span>{{modelName}}</span>
										</div>
										<div class="infos">{{infoTitle}}</div>
									</div>
								</div>
								<div class="infoD">
									<p>请选择购买数量</p>
									<div class="labelNum">
										<el-input-number v-model="project_num" size="small" @change="handleChange"
											:min="1" :max="10" label="描述文字"></el-input-number>
									</div>
									<el-radio-group v-model="radioType" @change="changeHandler">
										<el-radio class="radio" label="1">电话联系我</el-radio>
										<el-radio class="radio" label="2">邮箱联系我</el-radio>
									</el-radio-group>
									<div v-if="emFlag==true">
										<p>请输入邮箱地址：</p>
										<el-form :model="dynamicValidateForm" ref="dynamicValidateForm"
											label-width="100px" class="demo-dynamic">
											<el-form-item prop="email" :rules="[
									      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
									      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
									    ]">
												<el-input v-model="dynamicValidateForm.email"></el-input>
											</el-form-item>
										</el-form>
									</div>
								</div>
							</div>
							<div slot="footer" class="dialog-footer">
								<el-button @click="dialogFormVisible = false">取 消</el-button>
								<el-button type="primary" @click="handNopass('dynamicValidateForm')">确 定</el-button>
							</div>
						</el-dialog>
					</div>
					<div class="contL">
						<div class="selTop bgWhit">
							<h4 class="pd20 bgBlu font14 bold">基础选型</h4>
							<Steps :stepInfo="stepInfo"></Steps>
						</div>
						<!-- 选型器 -->
						<div class="selItem bgWhit">
							<h4 class="pd10 mt25 font16 bold">
								<i class="iconfont icon-weibiaoti15"></i><span class="ml10">选型器</span>
								<span class="fr font12 curhand" @click="handEmpty('')">清空</span>
							</h4>
							<h4 class="pd20 bgBlu font14 bold">过滤规格/尺寸</h4>
							<div>
								<div class="handitem">
									<el-steps :active="orderNum" direction="vertical">
										<el-step v-for="(item,index) in Coldata" :key="item.id">
											<template slot="description">
												<h1 class="color1 font14 item1"><i class="H-line"></i>{{item.label}}
												</h1>
												<div class="font14">
													<ul class="innerbox"
														v-if="item.rulename=='paramAdd' || typeof(item.rulename)=='undefined' ">
														<!-- {{v-if="Uitem.splitcol.length>0"}} param.indexOf(Sitem.zhi)!=-1 && -->
														<div v-for="(Sitem,Sindex) in item.data" :key="Sindex">
															<label v-if="firstFlag==true"
																:class="[param.indexOf(Sitem.zhi)!=-1?'spanItem itemred':'spanItem']">
																<!-- item.jsc_column<=resdata.jindu -->
																<div v-if="item.jsc_column<=orderNum"
																	class="curhand">
																	<span v-if="Sitem.cname!=''"
																		@click="handeClick($event,Sitem.zhi,item.jsc_column)">{{Sitem.cname}}</span>
																	<span v-else-if="Sitem.cname==''"
																		@click="handeClick($event,Sitem.zhi,item.jsc_column)">{{Sitem.xc1}}</span>
																</div>
																<!-- -if="item.jsc_column>resdata.jindu" -->
																<div v-else-if="item.jsc_column>orderNum"
																	class="nohand">
																	<span v-if="Sitem.cname!=''">{{Sitem.cname}}</span>
																	<span
																		v-else-if="Sitem.cname==''">{{Sitem.xc1}}</span>
																</div>
															</label>
															<!--  :class="[param.indexOf(Sitem.zhi)!=-1?'spanItem itemred':'spanItem']" -->
															<label v-else-if="firstFlag==false" class="spanItem">
																<div v-if="item.jsc_column<=orderNum"
																	class="curhand">
																	<span slot="reference" v-if="Sitem.cname!=''"
																		:class="[item.data.length==1?'firtID itemred':'firtID']"
																		:data-name='Sitem.xc1'
																		@click="handeClick($event,Sitem.zhi,item.jsc_column)">{{Sitem.cname}}</span>
																	<span slot="reference" v-else-if="Sitem.cname==''"
																		:class="[item.data.length==1?'firtID itemred':'firtID']"
																		:data-name='Sitem.xc1'
																		@click="handeClick($event,Sitem.zhi,item.jsc_column)">{{Sitem.xc1}}</span>
																</div>
																<div v-else-if="item.jsc_column>orderNum"
																	class="nohand">
																	<span slot="reference" v-if="Sitem.cname!=''"
																		:class="[item.data.length==1?'firtID itemred':'firtID']"
																		:data-name='Sitem.xc1'>{{Sitem.cname}}</span>
																	<span slot="reference" v-else-if="Sitem.cname==''"
																		:class="[item.data.length==1?'firtID itemred':'firtID']"
																		:data-name='Sitem.xc1'>{{Sitem.xc1}}</span>
																</div>
															</label>
														</div>
													</ul>
													<!-- 步进值展示 -->
													
													<ul class="innerbox" v-if="item.rulename=='step'">
														<label>
															<div class="inputItem">
																<!-- {{index}}-{{resdata.jindu}}-{{item.jsc_column}}-{{orderNum}} -->
																<el-input v-model="Iteminput[index]" placeholder=""
																	size="small"
																	@change="changBlur($event,item,item.jsc_column)"
																	@focus="changfocus($event,item,item.jsc_column)"
																	:disabled="item.jsc_column>orderNum || item.jsc_column<orderNum">
																</el-input>
																{{item.stepStart}}-{{item.stepEnd}}/{{item.stepNum}}
															</div>
														</label>
													</ul>
												</div>
											</template>

										</el-step>
									</el-steps>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 常浏览 -->
				<div class="justBetween barprebox" v-show="historyFlag==true">
					<div class="bgwhite" style="padding:20px 35px;margin-top:20px">
						<h1 class="color1 font18 item15 txl"><i class="H-line-4"></i>常被一起浏览的商品</h1>
						<el-divider class="divider20"></el-divider>
						<div class="flexRow">
							<div class="demo-image curhand">
								<div class="block blockInfocate" v-for="(item,index) in liulanInfo" :key="index"
									@mousemove="addClassload($event)" @mouseout="removeClassload($event)"
									@click="jumpurl(item.id)" :title="item.catid_name">
									<el-image style="width: 210px; height: 210px"
										:src="'https://images.mfcad.cn/'+item.thumb" fit="cover"
										@mousemove="ImgaddClassload($event)" @mouseout="ImgremoveClassload($event)">
									</el-image>
									<div class="font14 txl" style="width: 100%;line-height: 20px;">
										<!-- <p class="mt10 Cred">¥ 46.00起</p> -->
										<p class="bold overtitle">{{ item.title}}</p>
										<p class="col-999 overtitle">{{ item.catname }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 常购买商品 -->
				<div class="justBetween barprebox" v-show="buyFlag==true">
					<div class="bgwhite" style="padding:20px 35px;margin-top:20px">
						<h1 class="color1 font18 item15 txl"><i class="H-line-4"></i>常被一起购买的商品</h1>
						<el-divider class="divider20"></el-divider>
						<div class="flexRow">
							<div class="demo-image curhand">
								<div class="block blockInfocate" v-for="(item,index) in goodsInfo" :key='index'
									@mousemove="addClassload($event)" @mouseout="removeClassload($event)"
									@click="jumpurl(item.id)" :title="item.catid_name">
									<el-image style="width: 210px; height: 210px"
										:src="'https://images.mfcad.cn/'+item.thumb" fit="cover"
										@mousemove="ImgaddClassload($event)" @mouseout="ImgremoveClassload($event)">
									</el-image>
									<div class="font14 txl" style="width: 100%;line-height: 20px;">
										<!-- <p class="mt10 Cred">¥ 46.00起</p> -->
										<p class="bold overtitle">{{ item.title}}</p>
										<p class="col-999 overtitle">{{ item.catname }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>
<script>
	import Cookies from 'js-cookie'
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	// 步骤条组件
	import Steps from '@/components/step'
	// 纵向table组件
	import tableDetail from '@/components/tableComponent'
	// footer
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			Steps,
			tableDetail,
			vFooter
		},
		data() {
			return {
				srcList: [
					'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
					'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
				],
				url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				titleDec: "",
				stepInfo: {
					list: [{
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}, {
						status: '1',
					}],
					step: 0
				},
				current: -1,
				flag: true,
				cur: 0,
				// class变量
				itemred: '',
				// 地图
				map: {
					center: {
						lng: '',
						lat: ''
					},
					zoom: 15,
					show: true,
					dragging: true
				},
				address: '',
				ak: '',
				num: 0,
				handSize: '尚未确定型号',
				// 选型器数量
				Tcount: 0,
				// arrFlag: false,
				Imginfo: [],
				ImgTu: [],
				infoTitle: '',
				infoBrief: '',
				infoPdf: '',
				pdfurl: '',
				Pstr: [],
				handLoc: [],
				// 场购买
				goodsInfo: [],
				// 常浏览
				liulanInfo: [],
				Tstr: '',
				propFlag: false,
				RpropFlag: true,
				harr: [],
				tableData: [],
				dialogFormVisible: false,
				formLabelWidth: '60px',
				radioType: '1',
				infoIMG: '',
				// 收藏
				colFlag: true,
				// 喜欢
				likeFlag: true,
				dynamicValidateForm: {
					email: ''
				},
				emFlag: false,
				// 加减数据量
				project_num: 1,
				// 手机emial验证
				contact: 1,
				// goodSize: '',
				handTS: [],
				goods_id: '',
				modelName: '',
				httpFile: 'https://mfcad-parts-upload.oss-cn-hangzhou.aliyuncs.com/',
				Nofalg: false,
				// 选型器重新排列调取后台 接口
				param: [],
				Coldata: [],
				findata: '',
				dialogcollectVisible: false,
				colType: 4,
				// 收藏夹列表数据
				colList: '',
				firstFlag: true,
				// 显示模型是否选完
				handFlag: true,
				sizeImg: '',
				buttonIndex: 2,
				// 供应商其他产品
				compaygoods: [],
				// 浏览购买无数据隐藏
				buyFlag: false,
				historyFlag: false,
				infoData: [],
				tupAndsize: true,
				// cad模型
				flagCad: true,
				flagpdf: false,
				flagcompay: false,
				// pdf滚动
				local: false,
				modeData: [],
				connector: '',
				imgurl: '',
				// 全部选型
				allparam: [],
				isend: '',
				cadmessage: '请您先登录！',
				downnum: 0,
				cadsize: 0,
				addtime: '',
				openurl: '',
				src3d: '',
				flag3d: false,
				flag2d: false,
				flagpdf1: false,
				// 是否有数据
				flag404: false,
				flagshow: false,
				resdata: [],
				// 步进值
				Iteminput: [],
				itemIndex: 0,
				loginFlag: true,
				//判断第一个空之后获取key值进行选型顺序使用
				orderNum: 0,
				orderNumstep: 0, //选型左侧步骤数字
			};
		},
		created() {
			setTimeout(() => {
				if (this.$refs.loginIndex.loginFlag == false) {
					this.loginFlag = false
				} else {
					this.loginFlag = true;
				}
			}, 2000)
			this.goods_id = this.$route.query.goodsid;
			// 后台接口排列组合
			this.init('');
			// 选型器获取个数
			this.handNum();
			// 获取公司名称以及ak
			// this.handeak();
			// 产品信息
			this.handProinfo();
			// 面包屑
			this.handClocation();
			// 常被购买
			this.handRecomm();
			// 浏览
			this.handhistory();
			// 判断是否收藏
			this.handFlagColl();
			// 供应商其他产品
			this.handOther();
			// 浏览历史
			this.handbrowse();
			$('.shadow').css({
				'display': 'none',
			})
			setTimeout(() => {

				if (this.$refs.loginIndex.loginFlag == false) {
					this.cadmessage = "型号暂未确定，请先选型"
				} else if (this.$refs.loginIndex.loginFlag == true) {
					this.cadmessage = "请您先登录!"
				}
			}, 2000)
			this.src3d = 'https://static.mfcad.com/3d/index.html?product_id=' + this.goods_id + '&product_model=' + this
				.modelName

		},
		mounted() {
			window.addEventListener('scroll', this.btn_pos);
		},
		watch: {
			newWin() {
				window.open(this.openurl, "_blank");
			}
		},
		methods: {
			// 步进值
			changBlur(e, item, Sindex) {
				var stepStart = Number(item.stepStart.replace(/\D/g, ''))
				var stepEnd = Number(item.stepEnd.replace(/\D/g, ''))
				var stepNum = Number(item.stepNum.replace(/\D/g, ''))
				// 提取字母
				var stepA = item.stepStart.replace(/[^a-zA-Z]/g, '') //规则字母
				var inputA = this.Iteminput[Sindex].replace(/[^a-zA-Z]/g, '') //输入数据的字母
				var inputS = Number(this.Iteminput[Sindex].replace(/\D/g, '')) //输入数据的数字
				// console.log("cc", stepStart, stepEnd, stepNum, stepA, inputA, inputS);
				// return false
				if (inputA == stepA) {
					if (inputS >= stepStart && inputS <= stepEnd && (inputS % stepNum == 0)) {
						//Sindex是需要往param值push的时候用到
						// 当输入值匹配到区间值的时候此方法
						let iteminput = this.Iteminput
						let itemzhi
						item.data.some(function(item1, index1) {
							if (item1.xc1 === iteminput[Sindex]) {
								itemzhi = item1.zhi
								return true;
							}
						});
						if (this.param.indexOf(itemzhi) >= 0) {
							this.firstFlag = true
							Vue.set(this.param, Sindex, '')
						} else {
							this.firstFlag = false;
							Vue.set(this.param, Sindex, itemzhi)
							this.RpropFlag = true;
						}
						this.init(Sindex);
						this.handNum(this.param);
					} else {
						this.$message({
							type: 'error',
							message: '输入错误，最小值：' + item.stepEnd + '最大值：' + item.stepStart + '且必须为' + item.stepNum +
								'的倍数'
						});
					}
				} else {
					this.$message({
						type: 'error',
						message: '输入错误，最小值：' + item.stepEnd + '最大值：' + item.stepStart + '且必须为' + item.stepNum +
							'的倍数'
					});
				}

			},
			changfocus(e, item, Sindex) {
				// console.log("dd", this.Iteminput[Sindex])
				// if(this.Iteminput[Sindex]!='' && this.Iteminput[Sindex]!=undefined){
				// // this.firstFlag = true
				// this.param.splice(this.param.indexOf('0|?|1|?|10|?||?|0'), 1);
				// this.itemIndex = Sindex - 1
				// }else{
				//  console.log(111)
				//  this.firstFlag = false;
				//  this.param.push('0|?|1|?|10|?||?|0')
				//  this.RpropFlag = true;
				//  this.itemIndex = Sindex
				// }
			},
			// 联系我们
			handcontact1() {
				// console.log(this.$refs.loginIndex.loginFlag);return false;
				if (this.$refs.loginIndex.loginFlag == true) {
					this.$refs.loginIndex.handLogin(window.location.href)
				} else {
					// console.log(this.$refs.loginIndex.bindmobile)
					if (this.$refs.loginIndex.bindmobile == 1 && this.isend == 1) {
						this.$confirm('需要让供应商联系您吗?', '请联系我', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$postcn('partscate/inquiry', {
								project_id: this.goods_id,
								project_model: this.modelName,
								project_num: 0,
								contact_status: 1,
								phone: this.$refs.loginIndex.mobile
							}, this).then((res) => {
								this.$message({
									type: 'success',
									message: '已将您的联系方式发送给厂商，请耐心等待厂商联系!'
								});
							})

						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消供应商联系您'
							});
						});
					} else if (this.isend == 0) {
						this.$message({
							message: '请先选择好型号在进行此操作!',
							type: 'info',
							duration: '2000'
						});
					} else {
						this.$message({
							message: '请先绑定手机号!',
							type: 'info',
							duration: '2000'
						});
						setTimeout(function() {
							window.open('/people/nump', '_self');
						}, 2000)
					}
				}

			},
			handcontact2() {
				if (this.$refs.loginIndex.loginFlag == true) {
					this.$refs.loginIndex.handLogin(window.location.href)
				} else {
					let routeData = this.$router.resolve({
						name: "contact",
					})
					window.open(routeData.href, '_blank');
				}
			},
			// 图片轮播控制局部放大功能
			linkto() {
				let activeIndex = this.$refs.carousel.activeIndex
				this.imgurl = this.Imginfo[activeIndex].url
				var larger = this.$refs.larger;
				larger.style.display = "none";
			},
			// 局部放大
			getPosition: function(element) {
				var dc = document,
					rec = element.getBoundingClientRect(),
					x = rec.left, // 获取元素相对浏览器视窗window的左、上坐标 
					y = rec.top;
				// 与html或body元素的滚动距离相加就是元素相对于文档区域document的坐标位置 
				x += dc.documentElement.scrollLeft || dc.body.scrollLeft;
				y += dc.documentElement.scrollTop || dc.body.scrollTop;
				return {
					left: x,
					top: y
				};
			},
			handleMove(evt) {
				var larger = this.$refs.larger;
				var shadow = this.$refs.shadow;
				var big = this.$refs.big;
				var pos = this.getPosition(this.$refs.choose);
				var shadowRect = shadow.getBoundingClientRect();
				var bigRect = big.getBoundingClientRect();
				var contentRect = this.$refs.content.getBoundingClientRect();
				var maxX = contentRect.width - shadowRect.width;
				var maxY = contentRect.height - shadowRect.height;

				var X = evt.pageX - pos.left - shadowRect.width / 2;
				var Y = evt.pageY - pos.top - shadowRect.height / 2;
				if (X <= 0) {
					X = 0;
				}
				if (X >= maxX) {
					X = maxX;
				}
				if (Y <= 0) {
					Y = 0;
				}
				if (Y >= maxY) {
					Y = maxY;
				}
				// 防止遮罩层粘滞，跟随鼠标一起滑出大图位置
				var bigX = X * bigRect.width / contentRect.width;
				var bigY = Y * bigRect.height / contentRect.height;
				//  bigX / bigW = X / contentW,主图和遮罩层之间存在两倍关系，放大图和原图之间也有两倍关系
				shadow.style.left = X + "px";
				shadow.style.top = Y + "px";
				big.style.left = -bigX + "px";
				big.style.top = -bigY + "px";
				larger.style.display = "block";
				shadow.style.display = "block";
			},
			handleOut(evt) {
				
				var larger = this.$refs.larger;
				var shadow = this.$refs.shadow;
				larger.style.display = "none";
				shadow.style.top = "-1000px";
			},
			jumpurl(id) {
				let routeData = this.$router.resolve({
					name: "content",
					query: {
						goodsid: id
					}
				})
				window.open(routeData.href, '_blank');
			},
			mouseOverPdf(tab) {
				$('#tab-' + tab).animate({
					top: 0,
					left: 0,
					width: '110px',
				})
				$('#pdf' + tab).removeClass('hidepdf').addClass('showpdf')
				$('#tab-' + tab).siblings().find('span').removeClass('showpdf').addClass('hidepdf')
			},
			mouseLeavePdf(tab) {
				$('#tab-' + tab).siblings().not(".el-tabs__active-bar").animate({
					top: 0,
					left: '50px',
					width: '50px',
				})
				// $('#tab-' + tab).siblings().find('span').removeClass('showpdf').addClass('hidepdf')
			},
			handTab(tab) {
				if (!$('#tab-' + tab.index).hasClass('is-active')) {
					$('#tab-' + tab.index).animate({
						top: 0,
						left: 0,
						width: '110px',
					})
					$('#pdf' + tab.index).removeClass('hidepdf').addClass('showpdf')
				}
				$('#tab-' + tab.index).siblings().not(".el-tabs__active-bar").animate({
					top: 0,
					left: '50px',
					width: '50px',
				})
				$('#tab-' + tab.index).siblings().find('span').removeClass('showpdf').addClass('hidepdf')
			},
			btn_pos: function() {
				//滚动条的高度
				var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
				var clientHeight = document.documentElement.clientHeight;
				if (scrollTop < 200) {
					this.local = false
				} else if (scrollTop > 2100) {
					this.local = false
				} else {
					this.local = true
				}
				//滚动条的高度>可视区的高度
			},
			addClassload($event) {
				$event.currentTarget.className = "block blockInfocate active1";
			},
			removeClassload($event) {
				$event.currentTarget.className = "block blockInfocate";
			},
			ImgaddClassload($event) {
				$event.currentTarget.className = "el-image__inner Wactive";
			},
			ImgremoveClassload($event) {
				$event.currentTarget.className = "el-image__inner";
			},
			returnTop(index) {
				document.querySelector("#pdf" + index).scrollIntoView(true);
			},
			// 轮播图
			handSwiper(buttonIndex, type) {
				// setTimeout(function(){
				this.buttonIndex = buttonIndex
				this.src3d = 'https://static.mfcad.com/3d/index.html?product_id=' + this.goods_id + '&product_model=' +
					this.modelName;
					
				// 3d轮播图 // 图片 // 尺寸图
				if (type == "3d") {
					//	document.getElementById('3dload').contentWindow.location.reload(true);
					this.tupAndsize = false

				} else if (type == "tup") {
					this.tupAndsize = true
					this.Imginfo = this.ImgTu
					let activeIndex = this.$refs.carousel.activeIndex
					this.imgurl = this.Imginfo[activeIndex].url
					var larger = this.$refs.larger;
					larger.style.display = "none";
				} else if (type == "size") {
					this.tupAndsize = true
					this.Imginfo = this.sizeImg
					this.imgurl = ''
					let activeIndex = this.$refs.carousel.activeIndex
					this.imgurl = this.Imginfo[activeIndex].url
					var larger = this.$refs.larger;
					larger.style.display = "none";
				}
				// },1)

			},
			// 供应商其他产品
			handOther() {
				this.$postcn('partshome/other', {
					id: this.goods_id,
					userid: Cookies.get('userid')
				}, this).then((res) => {
					if (res.data.status == 1) {
						this.compaygoods = res.data.msg
						this.flagcompay = true
					} else if (res.data.status == -1) {
						this.flagcompay = false
					}
				})
			},
			// 选型器个数
			handNum(param) {
				this.$postcn('partshome/ty', {
					id: this.goods_id,
					param: param
				}, this).then((res) => {
					this.Tcount = res.data.data
				})
			},
			// 浏览历史
			handbrowse() {
				this.$postcn('partshome/browseRecord', {
					product_id: this.goods_id,
				}, this).then((res) => {

				})
			},
			changeHandler(value) {
				this.contact = value;
				if (value == '2') {
					this.emFlag = true;
				} else {
					this.emFlag = false;
				}
			},
			// 收藏弹窗以及确定收藏
			changeColHandler(value) {
				this.colType = value;
			},
			handFlagColl() {
				if (Cookies.get('mf_service_ticket') !== undefined) {
					this.$postcn('partshome/iscolletion', {
						id: this.goods_id
					}, this).then((res) => {
						// 1:已收藏，0：未收藏
						if (res.data == 0) {
							this.colFlag = true;
						} else if (res.data == 1) {
							this.colFlag = false;
						}
					})
				}
			},
			handColl() {
				this.$postcn('partshome/collection', {
					productid: this.goods_id,
					favorite_id: this.colType
				}, this).then((res) => {
					if (res.data.msg == '收藏成功') {
						this.$message({
							type: 'success',
							message: '收藏成功'
						});
						this.colFlag = false
						this.dialogcollectVisible = false;
						this.$refs.loginIndex.colnum = res.data.data
						
					} else if (res.data.msg == '取消成功') {
						this.$message({
							type: 'info',
							message: '取消收藏'
						});
						this.colFlag = true;
						this.$refs.loginIndex.colnum = res.data.data
					} else if (res.data.code == -4007) {
						this.$refs.loginIndex.handLogin(window.location.href)
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			},
			// 购物车加减
			handleChange(value) {
				this.project_num = value;
			},
			// 跳转企业主页
			handCjump(url, id) {
				
				let routeData = this.$router.resolve({
					path: url,
					query: {
						cid: id
					}
				})
				
				if (this.loginFlag == false) {
					window.open(routeData.href, '_blank');
				} else if (this.loginFlag == true) {
					this.$refs.loginIndex.handLogin(window.location.href + url)
				}
			},
			handProinfo() {
				this.$post('partshome/productshow', {
					p: 1,
					id: this.goods_id,
					pcount: 1
				}, this).then((res) => {
					if (res.data.data.length == 0) {
						this.flag404 = true
					} else {
						if (res.data.data[0] != undefined) {
							this.flagshow = true
							this.infoData = res.data.data[0]
							// 轮播图
							this.Imginfo = res.data.data[0].img_count;
							this.imgurl = res.data.data[0].img_count[0].url
							this.ImgTu = res.data.data[0].img_count;
							// 商品标题
							this.infoTitle = res.data.data[0].title;
							this.iuserid = res.data.data[0].userid;
							// 简介
							this.infoBrief = res.data.data[0].brief;
							// 样本内容
							this.flag3d = res.data.data[0].isthree
							this.flag2d = res.data.data[0].istwo
							// this.flagpdf = res.data.data[0].ispdf

							if (res.data.data[0].ispdf == 1) {

								this.flagpdf = true
								this.infoPdf = res.data.data[0].pdf;
								// this.pdfurl = res.data.data[0].pdf;
							} else {
								this.flagpdf = false
							}
							// 询价商品信息图
							this.Imginfo.map((item, index) => {
								this.infoIMG = this.Imginfo[0].url
							})
							// 尺寸图
							// if (res.data.data[0].img_size.length == 2) {
							// 	this.sizeImg = '/front/static/img/img1.74ae51d.jpg'
							// } else {
							this.sizeImg = res.data.data[0].img_size
							// }
						}
					}
				})
			},
			handClocation() {
				this.$post('partshome/currentlocation', {
					productid: this.goods_id
				}, this).then((res) => {
					this.handLoc = res.data;
				})
			},
			handUrl() {
				window.open(this.pdfurl, '_blank');
			},

			//购买
			handRecomm() {
				this.$post('partshome/togetherbuy', {
					id: this.goods_id
				}, this).then((res) => {
					if (res.data.status > 0) {
						this.buyFlag = true
						this.goodsInfo = res.data.msg
					} else {
						this.buyFlag = false
					}
				})
			},
			//购买
			handhistory() {
				this.$post('partshome/togetherview', {
					id: this.goods_id
				}, this).then((res) => {
					if (res.data.status > 0) {
						this.historyFlag = true
						this.liulanInfo = res.data.msg
					} else {
						this.historyFlag = false
					}
				})
			},
			handeColl() {
				if (Cookies.get('mf_service_ticket') !== undefined) {
					this.$postcn('partshome/favoriteList', {
						page: 1,
						pagesize: 1000,
						type: 'all'
					}, this).then((res) => {
						if (res.data.length == 0) {
							this.$message({
								type: 'info',
								message: '您尚未在个人中心收藏列表中新建心仪文件目录,请建好前来收藏！'
							});
						} else if (res.data.code == -4007) {
							this.$refs.loginIndex.handLogin(window.location.href)
						} else {
							if (res.data.code == 4001) {
								this.$message({
									type: 'info',
									message: res.data.msg
								});
							} else {
								if (this.colFlag == true) {
									this.dialogcollectVisible = true;
									this.colList = res.data.data;
								} else {
									this.handColl();
								}
							}
						}
					})

				} else {
					this.$refs.loginIndex.handLogin(window.location.href)
				}
			},
			handelike() {
				if (Cookies.get('mf_service_ticket') !== undefined) {
					this.$postcn('partshome/like', {
						pro_id: this.goods_id
					}, this).then((res) => {
						// 1:喜欢，0：取消喜欢
						if (res.data.status == 2) {
							this.likeFlag = true;
						} else if (res.data.status == 1) {
							this.likeFlag = false;
						} else if (res.data.code == -4007) {
							this.$refs.loginIndex.handLogin(window.location.href)
						}
					})
				} else {
					this.$message({
						type: 'error',
						message: "请先登录之后再进行此操作！"
					});
				}
			},
			handeak() {
				if (Cookies.get('mf_service_ticket') !== undefined) {
					this.$post('map/baiduak', {
						userid: Cookies.get('userid')
					}, this).then((res) => {
						this.address = res.data.address;
						this.ak = res.data.ak;
						this.getMap();
					})
				}

			},
			getMap() {
				let that = this;
				let url = 'http://api.map.baidu.com/geocoding/v3/';
				that.$jsonp('https://api.map.baidu.com/geocoding/v3/', {
					address: that.address,
					output: 'json',
					ak: that.ak,
					callbackName: 'showLocation'
				}).then(res => {
					that.showLocation(res)
				})
			},
			showLocation(e) {
				this.map.center = e.result.location;
			},
			handEmpty(keyindex) {
				// 清空给值
				this.param = []
				this.Iteminput = []
				this.$post('partshome/screencreat', {
					id: this.goods_id,
					param: this.param,
					key: keyindex
				}, this).then((res) => {
					this.Coldata = res.data.screen;
					this.findata = res.data.finish;
					this.stepInfo.step = 0
					this.connector = res.data.connector;
					this.isend = res.data.isend;
					if (res.data.isend == 1) {
						this.handFlag = false;
						this.modelName = res.data.mod;
						this.modeData = res.data
						// 进度条
						this.stepInfo.step = 10
					} else {
						this.handFlag = true;
						this.num = res.data.jindu;
						this.stepInfo.step = (this.num / this.allparam.length) * 10
					}
					if (res.data.mod == false) {
						this.flagCad = true
					} else {
						this.flagCad = false
						this.modelName = res.data.mod;
						this.modeData = res.data
					}
					this.firstFlag = true;
				})
				this.init(keyindex);
				this.handNum(this.param);

			},
			init(keyindex) {
				this.allparam = []
				this.$post('partshome/screencreat', {
					id: this.goods_id,
					param: this.param,
					key: keyindex
				}, this).then((res) => {
					this.resdata = res.data;
					this.Coldata = res.data.screen;
					this.allparam = res.data.allparam;
					this.param = res.data.param;
					// 选中后型号table表展示
					this.allparam.map((item, index) => {
						if (item.data[0].cname == "") {
							Vue.set(this.tableData, index, {
								key: item.label,
								value: item.data[0].xc1
							})
						} else {
							Vue.set(this.tableData, index, {
								key: item.label,
								value: item.data[0].cname
							})
						}

					})
					let num;
					// 顺序取值空赋值orderNum
					this.param.some(function(item, index) {
						if (item == "") {
							num = index
							return true;
						}
					});
					if (num == undefined) {
						this.orderNum = this.param.length
					} else {
						this.orderNum = num
					}
					this.connector = res.data.connector;
					this.isend = res.data.isend;
					this.findata = res.data.finish;
					// 选型完毕之后进行
					if (res.data.isend == 1) {
						this.handFlag = false;
						this.modelName = res.data.mod;
						this.modeData = res.data
						if (this.tupAndsize == false) {
							this.src3d = 'https://static.mfcad.com/3d/index.html?product_id=' + this.goods_id +
								'&product_model=' + this.modelName
						}
						// 
						// 进度条
						this.stepInfo.step = 10
						this.$post('partshome/getpartfileinfo ', {
							product_id: this.goods_id,
							product_model: this.modelName,
						}, this).then((res) => {
							
							if (res.data.code == 200) {
								this.flagCad = false
								this.modelName = res.data.msg.file_name;
								this.downnum = res.data.msg.down;
								this.cadsize = res.data.msg.file_size;
								this.addtime = res.data.msg.s_time;
								//this.modeData = res.data
							} else if (res.data.code == -4004) {
								this.cadmessage = "请您先去登录！"
								this.flagCad = true
							} else {
								this.cadmessage = res.data.msg
								this.flagCad = true
							}
						})
					} else {
						this.handFlag = true;
						this.num = res.data.jindu;
						this.stepInfo.step = (this.num / this.allparam.length) * 10
					}

				})
			},
			// 选型器效果
			handeClick(e, itemxc, index) {
				
				if (this.param.indexOf(itemxc) >= 0) {
					this.firstFlag = true
					
					this.param.map((item, index1) => {
						if (index1 >= index) {
							//控制当前取消的key值之后的所有值都为空
							Vue.set(this.param, index1, '')
							this.Iteminput[index1]=''
						}
					})
				} else {
					this.firstFlag = false;
					Vue.set(this.param, index, itemxc)
					this.RpropFlag = true;
				}
				this.init(index);
				this.handNum(this.param);
			},
			// 总数
			// 选型数据排列组合
			handeShare() {
				// console.log(1)
			},
			handPrice() {
				// console.log(this.handFlag)
				if (Cookies.get('mf_service_ticket') !== undefined) {
					if (this.handFlag == true) {
						this.$alert('请完善型号选择之后进行询价！');
						this.dialogFormVisible = false;
					} else {
						this.dialogFormVisible = true;
					}
				} else {
					this.$message({
						type: 'error',
						message: "请先登录之后再进行收藏操作！"
					});
				}
			},
			handNopass(formName) {
				if (this.emFlag == true) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.handSuccess()
						} else {
							// console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.handSuccess();
				}
			},
			handSuccess() {
				var param = {
					project_id: this.goods_id,
					project_model: this.modelName,
					project_num: this.project_num,
					contact_status: this.contact,
					email: this.dynamicValidateForm.email
				}
				this.$postcn('partshome/inquiry', param, this).then((res) => {
					if (res.data.code == 200) {
						this.$alert(res.data.msg, {
							showConfirmButton: false,
						});
					} else {
						this.$alert(res.data.msg, {
							showConfirmButton: false,
						});
					}
				})
			},
			handler({
				BMap,
				map
			}) {
				let me = this;
				// 鼠标缩放
				map.enableScrollWheelZoom(true);
				// 点击事件获取经纬度
				map.addEventListener('click', function(e) {
					console.log(e.point.lng, e.point.lat)
				})
			},
			//点击下载模型
			handown() {
				if (Cookies.get('mf_service_ticket') !== undefined) {
					if (this.flagCad == true) {
						this.$message({
							type: 'error',
							message: "暂无模型！"
						});
					} else {
						let newWin = window.open("about:blank");
						var addparam = {
							product_id: this.goods_id,
							product_model: this.modelName,
							//product_id:442,product_model:this.modelName
						}
						this.$postcn('partshome/adddown', addparam, this).then((res) => {
							if (res.data.code == 200) {
								//		this.openurl=res.data.downurl;
								newWin.location.href = res.data.downurl
								// window.open(res.data.downurl, '_blank')
							} else if (res.data.code < 0) {
								this.$message({
									type: 'error',
									message: res.data.msg
								});
								if (res.data.code == -4007) {
									this.$refs.loginIndex.handLogin(window.location.href)
								}
							}
						})
					}

				} else {
					this.$refs.loginIndex.handLogin(window.location.href)
				}
			},
			downPdf(url) {
				window.open(url, '_blank');
			}
		},
	}
</script>
<style>
	[v-cloak] {
		display: none !important;
	}
</style>
<style lang="stylus" scoped>
	.disnone {
		display: none
	}

	.disblock {
		display: block
	}

	.posrela {
		position: relative;
		bottom: -35px;
	}

	.infodiv {
		font-size: 14px;
		margin-top: 30px;
		color: #666666;
		line-height: 22px;
	}

	.w6 {
		width: 70px;
		text-align-last: justify;
		display: inline-block;
	}

	.csdiv {
		color: #9a9a9a;
		font-size: 14px;
		margin-right: 15px;
	}

	.titleover {
		width: 400px;
		overflow: hidden;
		display: inline-block;
		height: 20px;
		line-height: 20px;
		vertical-align: middle;
		font-size: 13px;
	}

	.el-popover--plain {
		padding: 5px !important;
	}

	.boderD {
		border: 1px solid #ccc;
		padding: 5px;
		color: #ccc
	}

	.infoD {
		padding-bottom: 20px;
	}

	.el-dialog__body {
		padding: 0px 20px !important
	}

	.el-dialog__header {
		padding: 20px 10px 10px 0px;
		border-bottom: 2px solid #0c5bad;
		margin: 0px 20px;
	}

	.corimg {
		width: 80px;
		height: 80px;
		display: inline;
		float: left;
	}

	.corimg img {
		width 100%;
		border: 1px solid #ccc;
	}

	.iconS {
		float: right;
	}

	.iconS.el-link.el-link--default {
		color: #005dbe
	}

	.corinfo {
		display: inline-block;
		margin-left: 20px;
		padding-top: 10px;
		line-height 25px;
	}

	.corinfo .infos {
		color: #005dbe;
	}

	.el-dialog {
		width: 25% !important;
		margin-top: 25%;
	}

	.el-breadcrumb {
		height: 62px;
		line-height 62px !important;
		font-size: 14px;
	}

	.el-input-group__append {
		background: none !important;
		border: none !important;
	}

	.el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
		color: #9298a2
	}

	.divider15 {
		margin: 15px 0px !important;
	}

	.divider20 {
		margin: 20px 0px !important;
	}

	.map {
		width: 100%;
		height: 400px;
	}

	.spanItem span {
		padding: 5px 0px;
		display: block
	}

	.labelNum {
		padding-bottom: 15px;
	}

	.el-form-item__content {
		margin-left: 0px !important;
	}

	.colRadio {
		height: 35px;
		line-height: 35px;
		width: 100px;
	}

	.icon-jiagecelve {
		font-size: 22px;
		vertical-align: middle;
	}

	.icon-fenxiang,
	.icon-shoucang,
	.icon-xihuan,
	.icon-xihuan1 {
		font-size: 22px;
		color: #9a9a9a;
		vertical-align: middle;
	}

	.tab-tilte .icon-yuedu,
	.icon-tubiao_daochuCAD,
	.icon-filepdf,
	.icon-goodsppesupplier {
		font-size 22px;
		vertical-align middle
	}

	// 商品排列样式
	.blockInfocate {
		padding: 10px 10px 20px 10px;
		text-align: center;
		display: inline-block;
		width: 235px;
		margin: 10px;
		box-sizing: border-box;
		vertical-align: top;
		background-color: #fFF;
		border: 1px solid #eaeaea;
	}

	.active1 {
		border-color: #1f75cf;
		// color: #1f75cf;
	}

	.Wactive {
		width: 190PX;
		cursor: pointer;
		transform: scale(1.5, 1.5)
	}

	.tab-cont {
		min-height: 700px;
		background: #ffffff;
		margin-top: 2px;
		padding-top 10px
	}

	.dowFile {
		// height: 44px;
		line-height: 44px;
		padding: 0px 30px;
		color: #666;
	}

	.dowFile .el-divider--horizontal {
		margin: 0px;
	}

	.pdfD {
		width: 10%;
		display: inline-block;
		vertical-align: top;
		line-height: 20px;
		color: #fff;
		font-weight: bold;
		cursor: pointer;
		position: fixed;
		left: 65%;
		// background: #fff;
		width: 56px;
		bottom: 130px;
		// z-index: 101;
		padding: 5px 30px;
	}

	.pdfD .el-icon-link {
		font-size: 18px;
		vertical-align: middle;
		display: inline;
	}

	.swiperbtn .btnICON {
		width: 48px;
		height: 46px;
		border: 1px solid #ccc;
		display: inline-block;
		text-align: center;
		border-radius: 5px;
	}

	.swiperbtn {
		text-align: center;
		margin-top: 20px;
	}

	.icon-Dxuanzhuan,
	.icon-tupian,
	.icon-icon-test1 {
		FONT-SIZE: 28PX;
		vertical-align: middle;
		line-height: 48px;
	}

	.Sactive {
		background-color: #005dbe;
		color: #FFFFFF;
	}

	.showpdf {
		display: inline-block;
	}

	.hidepdf {
		display: none;
	}

	.pdflist .icon-PDF,
	.icon-cad-fill {
		font-size: 32px;
		color: rgb(0, 141, 240);
	}

	// /deep/.el-table th > .cell {
	//   text-align: center;
	// }

	// /deep/.el-table .cell {
	//   text-align: center;
	// }
	.defaultIcon {
		color: #000000;
		font-weight: bold;
	}

	.redIcon {
		color: #005dbe;
		font-weight: bold;
	}

	#floatP {
		background: #ccc;
		padding-left: 10px;
		line-height: 30px;
	}

	// 局部放大

	.choose {
		width: 410px;
		height: 600px;
		float: left;
		margin: 10px 0 0 10px;
	}

	.content {
		width: 410px;
		height: 330px;
		position: relative;
	}

	.content img {
		width: 410px;
		height: 330px;
	}

	#listshow {
		width: 410px;
		height: 100px;
		margin-top: 20px;
	}

	#listshow li {
		width: 98px;
		height: 100px;
		float: left;
		border: 1px solid #666;
	}

	#listshow li img {
		width: 98px;
		height: 100px;
	}

	#listshow .selected {
		border-color: brown;
	}

	.larger {
		width: 410px;
		height: 330px;
		position: absolute;
		top: 20px;
		left: 450px;
		float: left;
		overflow: hidden;
		display: none;
	}

	.larger img {
		width: 820px;
		height: 550px;
		position: absolute;
	}

	.shadow {
		width: 200px;
		height: 200px;
		cursor: url('../../assets/big.png'), auto;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 8;
		display: none;
	}

	.colblue {
		color: #005dbe
	}

	// 选型器步骤条
	.stepOut {
		width: 100%;
		display: flex;
		justify-content: center;

		.stepline {
			width 100%
		}

		// ul {
		// 	width: 95%;
		// 	padding: 0;
		// 	margin-left: 5px;
		// }

		.stepItem {
			width: 100%;
			// height: 70px;
			// float: left;
			font-family: SimSun;
			font-size: 16px;
			// text-align: center;
			position: relative;

			.icon {
				width: 13px;
				height: 13px;
				border-radius: 50%;
				background: rgba(226, 226, 226, 1);
				// margin: 0 auto;
				position: relative;
				z-index: 888;
			}

			.active {
				background-color: green;
			}

			.line {
				position: absolute;
				top: 6px;
				left: 50%;
				border-bottom: 1px dashed rgba(3, 2, 2, 0.7);
				width: 260px;
				z-index: 111;
			}

			.lineActive {
				border-bottom: 1px solid green;
			}

			.stepStatus {
				color: rgba(87, 87, 87, 1);
				line-height: 36px;
			}

			.statusTime {
				color: rgba(87, 87, 87, 1);
				opacity: 0.5;
			}
		}
	}

	.nohand {
		cursor: not-allowed
	}

	.inputItem {
		padding: 6px 0px;
	}
</style>
<style>
	.pdftab .el-tabs--left .el-tabs__header.is-left {
		width: 50px;
	}

	.pdftab .el-tabs__item.is-active,
	.pdftab .el-tabs__item:hover {
		color: #000;
	}

	.pdftab .el-tabs__active-bar {
		background-color: #d9001b;
	}

	.pdftab .icon-filepdf {
		color: #d9001b;
	}

	.spanDown.el-button--primary.is-plain:hover,
	.spanDown.el-button--primary.is-plain {
		background-color: #005dbe !important;
		color: #FFFFFF !important;
		border: 1px solid #005dbe;
		border-radius: 3px;
		padding: 6px 8px;
	}

	.handitem .el-step.is-vertical .el-step__head {
		margin-top: 10px;
	}

	/* / * .el-step__description.is-finish, */
	.handitem .el-step__description.is-wait,
	.el-step__description.is-finish {
		color: #191c3d;
	}

	.handitem ul {
		width: 156px;
	}

	.handitem .el-step.is-vertical .el-step__main {
		padding-left: 0px;
	}

	.handitem .el-steps {
		padding-left: 10px;
	}

	/* 
	.spanDown.el-button--primary.is-plain {
		color: #005dbe;
		background: #ffffff;
		border-color: #005dbe;
		padding: 6px 8px;
	} */
	@keyframes lamp {
		0% {
			background: #F09115;
			box-shadow: 0 0 0 5px rgba(230, 0, 19, 0.2);
		}

		25% {
			background: transparent;
			box-shadow: none;
		}

		50% {
			background: #1682F0;
			box-shadow: 0 0 0 5px rgba(22, 130, 240, 0.2);
		}

		75% {
			background: transparent;
			box-shadow: none;
		}

		100% {
			background: #F09115;
			box-shadow: 0 0 0 5px rgba(230, 0, 19, 0.2);
		}
	}

	.handitem .el-step__head.is-process .el-step__icon.is-text {
		animation: lamp 2s linear infinite;

	}

	.handitem .is-process .el-step__icon.is-text {
		border-radius: 50%;
		border: none;
		border-color: inherit;
		color: #fff;
		background: #ccc;
	}

	.handitem .is-finish .el-step__icon.is-text {
		border-radius: 50%;
		border: none;
		border-color: inherit;
		color: #fff;
		background: #409EFF;
	}

	.handitem .el-step.is-vertical .el-step__line {
		top: 25px;
	}

	.handitem .el-step__icon {
		width: 18px;
		height: 18px;
		font-size: 12px;
	}

	.handitem .el-step.is-vertical .el-step__line {
		left: 8px;
	}

	[v-cloak] {
		display: none;
	}

	.inputItem input {
		width: 60px;
	}

	.inputItem .el-input {
		width: 60px;
		display: inline
	}
</style>



// WEBPACK FOOTER //
// src/pages/content/index.vue